import {clearCookies, deleteLoginCredentials} from '_/utilities';

export const logout = async (username: string): Promise<void> => {
  await deleteLoginCredentials(username);
  // logout from iam
  await fetch('/auth/rest/public/authentication', {
    headers: {'X-Same-Domain': '1'},
    method: 'DELETE',
  });

  // logout from backend
  const response = await fetch('/api/user-management/logout', {
    headers: {'X-Same-Domain': '1'},
    method: 'POST',
  });

  // clear cookies to make sure iam cookies are dismissed
  clearCookies();

  if (response.status === 204) {
    window.location.href = '/login/';
  }
};
